import React, { useEffect, useState, useContext } from "react";
import axiosBaseURL from "../../../httpCommon";
import { NavLink } from "react-router-dom";
import { imageURL } from "../../../constants";
import { DrtContext } from "../../../context/DrtContext";
import Loader from "../../Loader";

const Welcome = () => {
  const { EncryptDecrypt } = useContext(DrtContext);
  const [about, setAbout] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const getAbout = async () => {
    try {
      setLoading(true);
      const result = await axiosBaseURL.get("/site/about");
      const temp = EncryptDecrypt(result.data);
      setAbout(temp.data);
      setLoading(false);
    } catch (error) {
      setError("An error occurred while fetching the data.");
      setLoading(false);
    }
  };

  useEffect(() => {
    getAbout();
  }, []);

  if (loading) return <Loader />;
  if (error) return <div role="alert">Error: {error}</div>;
  if (!about) return null;

  const toShow = about.body.substring(0, 450) + "...";

  return (
    <section
      id="wel-wraper"
      className="container"
      role="region"
      aria-labelledby="welcome-heading"
    >
      <div className="about-bg">
        <div className="row align-items-center">
          {/* Text Section */}
          <div className="col-12 col-sm-12 col-md-12 col-lg-7">
            <div className="about-content">
              <h2 id="welcome-heading">Welcome to {about.title || "Our Platform"}</h2>
              <div
                className="about-wrap"
                dangerouslySetInnerHTML={{ __html: toShow }}
                aria-label="Brief about section content"
              ></div>
              <NavLink
                to="/aboutus"
                className="btn readmore"
                aria-label="Read more about this organization"
              >
                Read More <i className="fas fa-long-arrow-alt-right" aria-hidden="true"></i>
              </NavLink>
            </div>
          </div>

          {/* Image / Video Section */}
          <div className="col-12 col-sm-12 col-md-12 col-lg-5">
            <figure className="video-bg">
              <img
                src={`${imageURL}/playvideo.jpg`}
                className="img-fluid"
                alt="Thumbnail representing our welcome video or introduction"
                loading="lazy"
              />
              <figcaption className="visually-hidden">
                Preview image for welcome video
              </figcaption>
            </figure>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Welcome;
